import { credit } from '@/config';
const request = window.axios;

/**
 *
 * @param {string} url
 * @param {string} method
 * @param {object} json
 * @return {Promise} Promise
 */
export const featchTags = (url, method, json) => {
  method = method || 'get';
  let params = {};
  let data = {};
  if ('get' === method.toLowerCase()) {
    params = { ...json };
  } else if ('post' === method.toLowerCase()) {
    data = { ...json };
  }
  return request({
    url,
    method,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', credit },
    params,
    data
  });
};
